import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class MainOther extends Component {
    render() {
        return (
            <div>
                <div className="header">
                    <nav className="navbar navbar-default h-main">
                        <div className="container">
                            <div className="navbar-header">
                                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                </button>
                                <a href="/" className="navbar-brand">
                                    <img src="/images/new/ruhu-logo-13.png" alt="HOME" style={{width: '150px'}}/>
                                </a>
                            </div>
                        </div>
                    </nav>
                </div>
                <div className="main-content mt-20">
                    <div className="container w-30">
                        {this.props.children}
                    </div>
                </div> 
                
            </div>
        );
    }
}

export default MainOther